import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import clsx from "clsx";
import { MouseEventHandler, forwardRef } from "react";
import { Theme } from "react-migration/lib/theme/Theme";

enum DisabledTextContentColor {
  Light = "text-text-base-primary-disabled",
  // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
  Dark = "text-text-base-primary-disabled",
}

enum DisabledBorderColor {
  Light = "border-border-button-disabled",
  Dark = "border-border-action-disabled",
}

const DatePickerInput = forwardRef(
  (
    props: {
      onClick?: MouseEventHandler<HTMLElement>;
      value?: JSX.Element;
      placeholder?: JSX.Element;
      theme?: Theme;
      disabled?: boolean;
      labelClassName?: string;
      className?: string;
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ref: any
  ) => {
    const theme = (props.theme as Theme) || Theme.Light;
    return (
      <div
        onClick={props.onClick}
        className={clsx(
          "flex items-center z-50",
          "border border-solid rounded-md",
          props.disabled
            ? `cursor-not-allowed ${DisabledBorderColor[theme]}`
            : "cursor-pointer border-neutral-300 hover:border-platform-600 justify-between",
          props.className
        )}
      >
        <label
          onClick={props.onClick}
          ref={ref}
          className={`${props.disabled ? DisabledTextContentColor[theme] : ""} px-1 ${
            props.labelClassName ? props.labelClassName : ""
          }`}
        >
          {props.value || props.placeholder}
        </label>
        <i
          className={`icon-lt-calendar-line text-base px-1 ${props.disabled ? DisabledTextContentColor[theme] : ""}`}
        />
      </div>
    );
  }
);

DatePickerInput.displayName = "DatePickerInput";

export { DatePicker, DatePickerInput };
